module.exports = __webpack_public_path__ + "static/JukeBox-e3e9a002786b273efa3b622a6c5ae5ab.png";